import { PreviewPaneHeader } from '@/components/features/preview-pane-header'

export type IndexPreviewEmptyProps = {
  /** Omit for location-only / unlabeled peeks (todo preview). */
  label?: string
  noun: string
  onClose: () => void
  testId?: string
  headerTestId?: string
  /** Match a folder filter row so the empty peek header sits on that line. */
  row?: boolean
}

/** Empty Continuity peek: header + close + teach copy. Never a headerless island. */
export function IndexPreviewEmpty({
  label,
  noun,
  onClose,
  testId,
  headerTestId,
  row = false,
}: IndexPreviewEmptyProps) {
  return (
    <div className="flex h-full min-h-0 flex-col bg-card" data-testid={testId}>
      <PreviewPaneHeader row={row} testId={headerTestId} label={label} onClose={onClose} />
      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center text-sm text-muted-foreground">
        <p>Select a {noun} to preview</p>
        <p className="mt-2 text-xs">Or choose Preview from the row menu.</p>
      </div>
    </div>
  )
}
